import { useEffect } from 'react';

import { useAnalyticsContext } from '../../../modules/analytics/AnalyticsContext';

export default ({
  error,
  isClientError,
}: {
  error?: string;
  isClientError?: boolean;
}) => {
  const {
    analytics: { trackLink },
  } = useAnalyticsContext();

  useEffect(() => {
    if (!error) {
      return;
    }

    trackLink({
      eventName: 'alert_viewed',
      alertShownType: !isClientError ? 'error' : 'notice',
      alertShownMessage: error,
      alertShownPosition: 'content',
    });
  }, [trackLink, error, isClientError]);
};
